import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { TranslationKey, useTranslation } from '../translations';
import { Fetcher, renderName, useFetcher } from '../utils';

interface UserListModalProps {
  readonly title: TranslationKey;
  readonly userList: number[];
  readonly close: () => void;
}

export const UserListModal: FC<UserListModalProps> = ({ title, userList, close }) => {
  const { ts } = useTranslation();
  const userRequest = useFetcher(async () => {
    return await api.getUsersByIds(userList);
  }, [userList]);

  return (
    <Modal isOpen toggle={close}>
      <ModalHeader toggle={close}>{ts(title)}</ModalHeader>
      <ModalBody>
        {userRequest.success ? (
          <>
            {ts('total_results')}: {userRequest.data.users.length}
            <ol>
              {userRequest.data.users.map((reg) => {
                return (
                  <li id={`user${reg.id}`} key={reg.id}>
                    <Link to={`/housekeeping/attendees/user/${reg.id}`}>{renderName(reg)}</Link>
                  </li>
                );
              })}
            </ol>
          </>
        ) : (
          <Fetcher result={userRequest} />
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={close}>
          {ts('common.close')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
